import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;



// Titlecloudcompute
function SohoENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Soho - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("소호형(한비로구성도)")} */}
                        {/* {Contentcloudcard("","")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='MuiGrid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Small-scale Private Kubernetes Architecture</p>",

                                `
                                <p class='typo-14'>The SOHO version of Private Kubernetes operates Master and Worker nodes as VMs.</p>
                                <p class='typo-14'>Uses Proxmox VE virtualization servers, enabling a private Kubernetes cluster with at least 2 nodes.</p>
                                <p class='typo-14'>&nbsp;</p>
                                <ul>
                                    <li><p class='typo-14'>Small cluster utilizing Proxmox VE nodes.</p></li>
                                    <li><p class='typo-14'>Optimized lightweight solution suitable for small teams and startups.</p></li>
                                    <li><p class='typo-14'>Ideal for operating small-scale applications.</p></li>
                                    <li><p class='typo-14'>Cost-effective with quick deployment.</p></li>
                                    <li><p class='typo-14'>Suitable for testing and development environments.</p></li>
                                </ul>
                                `)}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/back-office-1.png")}</MuiGrid>
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/back-office-2.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>


            <FooterEn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default SohoENG;